import MUIDataTable from "mui-datatables";
import { useEffect, useState } from "react";

const Invoices = (props) => {
    const [invoicesTableData, setInvoicesTableData] = useState([]);

    useEffect(() => {
        let data = props.data;

        // Check for empty data and skip processing
        if (data.length === 0) return;

        // Check for undefined values and replace
        data = data.map((item) => {
            Object.keys(item).forEach((key) => {
                if (item[key] === undefined || item[key] === null) {
                    item[key] = "-";
                }

                if (key === "total") {
                    if (item[key] == null) item[key] = 0;
                }
            });
            return item;
        });

        data.sort((a, b) => new Date(b.trandate) - new Date(a.trandate));

        setInvoicesTableData(data);
    }, [props.data]);

    const columns = [
        {
            name: "trandate",
            label: "Date / Due Date",
            options: {
                customBodyRenderLite: (dataIndex) => {
                    const item = invoicesTableData[dataIndex];
                    if (item.trandate !== "-") {
                        let date = new Date(item.trandate);
                        return date.toLocaleDateString("en-US");
                    } else return "-";
                },
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                        paddingLeft: "0px",
                    },
                }),
            },
        },
        {
            name: "license_start_date",
            label: "License Start",
            options: {
                customBodyRenderLite: (dataIndex) => {
                    const item = invoicesTableData[dataIndex];
                    if (item.license_start_date && item.license_start_date !== "-") {
                        let date = new Date(item.license_start_date);
                        return date.toLocaleDateString("en-US");
                    } else return "-";
                },
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                        paddingLeft: "0px",
                    },
                }),
            },
        },
        {
            name: "transaction_type",
            label: "Type",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                        paddingLeft: "0px",
                    },
                }),
            },
        },

        {
            name: "tranid",
            label: "Ref",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                        paddingLeft: "0px",
                    },
                }),
            },
        },
        {
            name: "products",
            label: "Products",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                        paddingLeft: "0px",
                    },
                }),
            },
        },
        {
            name: "status_name",
            label: "Status",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                        paddingLeft: "0px",
                    },
                }),
            },
        },
        {
            name: "total",
            label: "Total",
            options: {
                customBodyRender: (value, tableMeta, updateValue) =>
                    (value =
                        "$" +
                        value.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                        })),
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",

                        textAlign: "right",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                        paddingLeft: "0px",
                    },
                }),
            },
        },
        {
            name: "currency",
            label: "Currency",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                        paddingLeft: "0px",
                    },
                }),
            },
        },
        {
            name: "days_overdue",
            label: "Days Overdue",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                        paddingLeft: "0px",
                    },
                }),
            },
        },
    ];

    const options = {
        responsive: "standard",
        selectableRows: "none",
        searchAlwaysOpen: false,
        storageKey: "invoicesTable",
        filter: true,
        sort: true,
        rowsPerPage: 25,
        rowsPerPageOptions: [10, 25, 50, 100],
        print: false,
        download: false,
        search: true,
        columnOrder: null,
        fixedHeader: false,
    };

    return (
        <div className="mt-12 flex w-full flex-col">
            <h4 className="pb-2">Invoices & Payments</h4>

            <MUIDataTable
                data={invoicesTableData}
                columns={columns}
                options={options}
                style={{ marginTop: "50px" }}
                className="ngShadow"
            />
        </div>
    );
};

export default Invoices;
